import {ProgramService} from 'services/programService';
import {createEntityThunks} from 'utils/createEntityThunks';
import {Program} from 'types/program';

const programFactory = (data: any) => new Program(data);

class BaseProgramsThunks extends createEntityThunks<Program>(
  'program',
  ProgramService,
  {activate: true, deactivate: true},
  programFactory,
) {}

export class ProgramsThunks extends BaseProgramsThunks {}
